import axios from 'axios'
import {API_URL} from './config.js'

export default {
  getSellRanking: function (nodeId) {
    return new Promise((resolve, reject) => {
      axios.get(`${API_URL}/SellRanking/${nodeId}`,this.getBearerToken()).then(response => {
        // JSON responses are automatically parsed.
        resolve(response)
      }).catch(e => {
        console.log(e)
        // this.errors.push(e)
        // alert(e.message)
        reject(e)
      })
    })
  }
}


// WEBPACK FOOTER //
// ./src/leaderboard.js